/* eslint-disable react-hooks/exhaustive-deps */
import { type Dispatch, type SetStateAction, useEffect, useState } from 'react';

export const useLocalStorage = <T extends object | string>(
  storageKey: string,
  defaultState: T,
): [T, Dispatch<SetStateAction<T>>] => {
  const [value, setValue] = useState<T>(getItem(storageKey, defaultState));

  useEffect(() => {
    localStorage.setItem(storageKey, JSON.stringify(value));
  }, [value]);

  useEffect(() => {
    setValue(getItem(storageKey, defaultState));
  }, [storageKey]);

  return [value, setValue];
};

const getItem = <T extends object | string>(
  storageKey: string,
  defaultState: T,
) => {
  const savedJSON = localStorage.getItem(storageKey);
  if (!savedJSON) return defaultState;

  return JSON.parse(savedJSON);
};
